import clsx from "clsx";
import useTransactionsChart from "./hooks/useTransactionsChart";
import { TransactionsChartProps } from "./TransactionsChart.types";
import StatsChartCard from "ui/stats/components/display/StatsChartCard/StatsChartCard";

function TransactionsChart({ className, ...rest }: TransactionsChartProps) {
    const props = useTransactionsChart();
    return <StatsChartCard className={clsx("transactions-chart-card", className)} {...props} {...rest} />;
}

export default TransactionsChart;
